<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.phone, 'Număr de telefon')"
      v-model="phoneNumber"
      :rules="phoneNumberValidationRules"
      name="phoneNumber"
      variant="outlined"
      bg-color="surface"
      :tile="true"
      counter="10"
      type="number"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex } = toRefs(props);
    const phoneNumber = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      phoneNumber.value = newValue;
    });

    watch(phoneNumber, (newValue) => {
      const valueToValidate = newValue || '';
      const isValid = validatePhoneNumber(valueToValidate);
      emit('update:modelValue', valueToValidate);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `phone_number-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `phone_number`, isValid });
      }
    });

    watch(modelValue, (newValue) => {
      if (newValue && validatePhoneNumber(newValue)) {
        phoneNumber.value = newValue;
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const phoneNumberValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[0-9]{10}$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validatePhoneNumber(phoneNumber: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        if (!phoneNumber) {
          error.value = [translation(translationList.value.required, 'Acest câmp este obligatoriu')];
          return false;
        }
      }
      const result = /^[0-9]{10}$/.test(phoneNumber);

      if (showErrors) {
        if (!result) {
          error.value = [translation(translationList.value.invalid_field, 'Acest câmp este invalid.')];
          return false;
        }
      }
      return result;
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validatePhoneNumber(phoneNumber.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `phone_number-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `phone_number`, isValid });
      }

      // Listen for validate events
      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `phone_number-${customerIndex.value}` || data.detail === `phone_number`)) {
        const isValid = validatePhoneNumber(phoneNumber.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: data.detail, isValid });
        }
      }
    };

    return {
      phoneNumber,
      phoneNumberValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>